import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from './shared.service';
import { UploadFileData } from '../Models/master';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {

  private baseUrl = 'http://localhost:8083';

  constructor(private _sharedService: SharedService) { }

//   upload(file: File): Observable<HttpEvent<any>> {
//     const formData: FormData = new FormData();

//     formData.append('file', file);

//     const req = new HttpRequest('POST', `${this.baseUrl}/UploadFile`, formData, {
//       reportProgress: true,
//       responseType: 'json'
//     });

//     return this.http.request(req);
//   }

//   getFiles(): Observable<any> {
//     return this.http.get(`${this.baseUrl}/files`);
//     this._sharedService.GetStaticContent
//   }


upload(uploadFileData:UploadFileData): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    if(uploadFileData.File != undefined){
        formData.append('file', uploadFileData.File);
        formData.append('Purpose',uploadFileData.Purpose);
    }
    return this._sharedService.PostWithFile("Master/UploadFile",formData)
}

uploadReview(uploadFileData:UploadFileData): Observable<HttpEvent<any>> {
  const formData: FormData = new FormData();
  if(uploadFileData.File != undefined){
      formData.append('file', uploadFileData.File);
      formData.append('Purpose',uploadFileData.Purpose);
      if(uploadFileData.DownloadFilePath !=''){
        formData.append('DownloadFilePath',uploadFileData.DownloadFilePath);
      }

  }
  return this._sharedService.PostWithFile("Master/UploadReviewFile",formData)
}

DeleteFile(fileName:string){
    let Data = {FileName: fileName}   
    return this._sharedService.Post("Master/DeleteFile", Data);
}


DownloadFile(fileName:string){
    let Data = {FileName: fileName}   
    return this._sharedService.DownloadFile("Master/DownloadFile", Data);
}



}